import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';
import { GoalShape } from 'entities';

const Goal = props => {

  const {isEmpty, goal = {}} = props;

  function handleMinusClick() {
    props.onDecrease(goal);
  }

  function handlePlusClick() {
    props.onIncrease(goal);
  }

  const className=classnames('Goal', {'is-empty': isEmpty});

  return (
    <tr className={className}>
      <td>
        <h5>{goal.goal}</h5>
      </td>

      <td>
        <div className="score">
          <div className="number">{goal.score}</div>

          <div className="icon-minus" onClick={handleMinusClick}></div>
          <div className="icon-plus" onClick={handlePlusClick}></div>
        </div>
      </td>
    </tr>
  );
};

Goal.propTypes = {
  goal: GoalShape,
  isEmpty: PropTypes.bool,
  onIncrease: PropTypes.func,
  onDecrease: PropTypes.func
};

export default Goal;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/containers/Goals/Goal/index.js
 **/